module.exports = __webpack_public_path__ + "img/l-1.8f2093ae.jpg";